<template>
  <div class="card-page-container mdl-shadow--2dp">
    <div class="mdl-card fill">
      <div class="mdl-card__title">
        <h2 class="mdl-card__title-text">{{ 'admin.services.billingPeriods.title' | label }}</h2>
      </div>
      <div v-show="!billingPeriodsCollapsed">
        <div class="mdl-card__supporting-text fill">
          <div class="mdl-grid" v-for="period of periods">
              <div class="mdl-cell mdl-cell--3-col">
                <div class="profile-label">
                  {{ period.label | label }}
                </div>
              </div>
              <div class="mdl-cell mdl-cell--3-col">
                <div class="profile-label">
                  <input class="mdl-textfield__input" v-model="period.label">
                </div>
              </div>
              <div class="mdl-cell mdl-cell--3-col">
                <div class="profile-label">
                  <input class="mdl-textfield__input" v-model="period.value">
                </div>
              </div>
              <div class="mdl-cell mdl-cell--3-col">
                <div>
                  <label class="mdl-checkbox mdl-js-checkbox mdl-js-ripple-effect" for="{{period.code}}-enabled">
                  <input type="checkbox" id="{{period.code}}-enabled" class="mdl-checkbox__input"
                    v-model="period.isActive">
                      <span class="mdl-checkbox__label">{{ 'admin.services.enabled' | label }}</span>
                  </label>
                </div>
              </div>
          </div>
        </div>
        <div class="mdl-card__actions">
          <div class="submit-button mdl-button mdl-js-button mdl-button--raised mdl-button--colored float-right"
          v-on:click="$emit('saveBillingPeriods')">
            {{'admin.parameters.button.save' | label}}
          </div>
          <div class="clearfix"></div>
        </div>
      </div>
      <div class="mdl-card__menu">
        <button class="mdl-button mdl-button--icon mdl-js-button mdl-js-ripple-effect"
          v-show="!billingPeriodsCollapsed"
          v-on:click="billingPeriodsCollapsed = true">
          <i class="material-icons">keyboard_arrow_up</i>
        </button>
        <button class="mdl-button mdl-button--icon mdl-js-button mdl-js-ripple-effect"
          v-show="billingPeriodsCollapsed"
          v-on:click="billingPeriodsCollapsed = false">
          <i class="material-icons">keyboard_arrow_down</i>
        </button>
      </div>
    </div>
    <div v-for="service in services">
      <service-form :service.sync="service" :billing-periods="billingPeriods"></service-form>
    </div>
  </div>
</template>

<script>
  var api = require('api')
  module.exports = {
    ready: function () {
      this.$dispatch('loading', true)
      api.BillingPeriod.get()
        .then(this.loadPeriods)
        .then(this.getServices)
        .catch(this.onError)
    },
    components: {
      serviceForm: require('a/forms/ServiceForm')
    },
    data: function () {
      return {
        services: [],
        billingPeriods: {},
        periods: [],
        billingPeriodsCollapsed: false
      }
    },
    methods: {
      getServices: function (response) {
        return api.Service.get()
          .then(this.loadServices)
          .catch(this.onError)
      },
      loadServices: function (response) {
        this.$dispatch('loading', false)
        this.services = response.data
      },
      onSuccess: function () {
        this.$dispatch('loading', false)
        this.$dispatch('show-success', 'admin.services.success.label')
      },
      onError: function (err) {
        this.$dispatch('loading', false)
        this.$dispatch('show-error', err)
      },
      loadPeriods: function (response) {
        this.$dispatch('loading', false)
        var periods = response.data
        var self = this
        periods.forEach(function (period) {
          self.billingPeriods[period.code] = period
          self.periods.push(period)
        })
        console.log('in load periods')
        return Promise.all(periods)
      }
    },
    events: {
      saveBillingPeriods: function () {
        console.log(this.periods)
        this.$dispatch('loading', true)
        api.BillingPeriod.bulkUpdate(JSON.stringify(this.periods))
        .then(this.onSuccess)
        .catch(this.onError)
      },
      saveService: function (service) {
        this.$dispatch('loading', true)
        api.Service.update({
          code: service.code
        }, service)
        .then(this.onSuccess)
        .catch(this.onError)
      }
    }
  }
</script>
<style>
.mdl-card {
  min-height: 0;
}
</style>



// WEBPACK FOOTER //
// Services.vue?3b23ee1e